// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { useEffect, useState } from 'react';
import Contact from './Sections/Contact';
import About from './Sections/About';
import Service from './Sections/Service';
import Intro from './Sections/Intro';
import Footer from './Sections/Footer';
import Work from './Sections/Work';
import {
  faFacebookF,
  faLinkedinIn,
  faReact,
  faLaravel,
  faGithub,
} from '@fortawesome/free-brands-svg-icons';
import {
  faMobile,
  faEnvelope,
  faComputer,
  faListCheck,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faFacebookF,
  faLinkedinIn,
  faEnvelope,
  faMobile,
  faComputer,
  faReact,
  faLaravel,
  faGithub,
  faListCheck
);

const DATA_URL =
  'https://script.google.com/macros/s/AKfycbxZoOmnp6qAkGki3F5FftCikba_2x_fXo-QJIYvVns2WCzHkiyhVBKC6eNNKmsdoKyd/exec';

function getSheetUrl(sheetName) {
  const url = new URL(DATA_URL);
  url.searchParams.set('sheetName', sheetName);
  return url.toString();
}

function setData(url, setData) {
  fetch(url)
    .then((response) => response.json())
    .then((response) => setData(response.data));
}

function checkLoading(data) {
  if (data.length === 0 || Object.keys(data).length === 0)
    return (
      <div className="animation-container">
        <div className="preloader" data-animation-delay="50">
          <div className="spinner"></div>
        </div>
      </div>
    );
}

function App() {
  const dateOptions = {
    year: 'numeric',
    month: 'long',
  };

  const [contactMethods, setContactMethods] = useState([]);
  const [experience, setExperience] = useState([]);
  const [skills, setSkills] = useState([]);
  const [bio, setBio] = useState({});
  const [education, setEducation] = useState([]);
  const [siteDescription, setSiteDescription] = useState({});
  const [socials, setSocials] = useState([]);

  const bioUrl = getSheetUrl('Bio');
  const contactMethodUrl = getSheetUrl('ContactMethods');
  const experienceUrl = getSheetUrl('Experience');
  const skillsUrl = getSheetUrl('Skills');
  const educationUrl = getSheetUrl('Education');
  const siteDescriptionUrl = getSheetUrl('Site');
  const socialsUrl = getSheetUrl('Socials');

  useEffect(() => {
    setData(contactMethodUrl, setContactMethods);
    setData(experienceUrl, setExperience);
    setData(bioUrl, setBio);
    setData(skillsUrl, setSkills);
    setData(educationUrl, setEducation);
    setData(siteDescriptionUrl, setSiteDescription);
    setData(socialsUrl, setSocials);
  }, [
    contactMethodUrl,
    experienceUrl,
    bioUrl,
    skillsUrl,
    educationUrl,
    siteDescriptionUrl,
    socialsUrl,
  ]);

  return (
    <>
      <div className="image-container">
        <div className="background-img fade-in"></div>
      </div>
      {/* <!-- /IMAGE CONTAINER --> */}

      {/* <!-- CONTENT AREA --> */}
      <div className="content-area">
        {/* <!-- CONTENT AREA INNER --> */}
        <div className="content-area-inner">
          {/* <!-- INTRO --> */}
          <Intro
            checkLoading={checkLoading}
            bio={bio}
            direction="left"
          />
          {/* <!-- /INTRO --> */}

          {/* <!-- ABOUT --> */}
          <About
            checkLoading={checkLoading}
            siteDescription={siteDescription}
            direction="right"
          />
          {/* <!-- /ABOUT --> */}

          {/* <!-- SERVICE --> */}
          <Service
            checkLoading={checkLoading}
            skills={skills}
            direction="left"
          />
          {/* <!-- /SERVICE --> */}

          {/* <!-- WORK --> */}
          <Work
            checkLoading={checkLoading}
            experience={experience}
            dateOptions={dateOptions}
            title="Work"
            direction="right"
          />
          {/* <!-- /WORK --> */}

          {/* <!-- EDUCATION --> */}
          <Work
            checkLoading={checkLoading}
            experience={education}
            dateOptions={dateOptions}
            title="Education"
            direction="left"
          />
          {/* <!-- /EDUCATION --> */}

          {/* <!-- CONTACT --> */}
          <Contact
            checkLoading={checkLoading}
            contactMethods={contactMethods}
            direction="right"
          />
          {/* <!-- /CONTACT --> */}

          {/* <!-- FOOTER --> */}
          <Footer socials={socials} direction="left" />
          {/* <!-- /FOOTER --> */}
        </div>
        {/* <!-- /CONTENT AREA INNER --> */}
      </div>
      {/* <!-- /CONTENT AREA --> */}
    </>
  );
}

export default App;
